import React from "react"
import { useDispatch } from "react-redux"

import Button from "@ng-mw/reol/components/Button"
import SafeHtml from "@ng-mw/reol/components/SafeHtml"

import "./style/top-banner-popup.scss"
import { hideTopBannerPopup } from "@app/store/app/appActions"
import { PopupButtons, PopupContent, PopupText, PopupTitle } from "@modules/popup/Popup"
import { InfoBannerApiResponse } from "@app/store/settings/types"
import { TextLink } from "@ng-mw/shared-react-components/shared"

const TopBannerPopupContent = (infoBannerResponse: InfoBannerApiResponse) => {
    const dispatch = useDispatch<any>()

    const handleClose = () => {
        dispatch(hideTopBannerPopup())
    }

    const bannerPopupContent = infoBannerResponse?.banner?.dialogContent

    const linkUrl = bannerPopupContent?.externalLink?.url
    const linkText = bannerPopupContent?.externalLink?.label ?? "Les mer"

    return (
        <>
            {bannerPopupContent?.image?.url ? (
                <img
                    className="top-banner-popup__image"
                    src={bannerPopupContent.image.url}
                    aria-hidden="true"
                    alt=""
                />
            ) : null}
            {bannerPopupContent?.title ? <PopupTitle>{bannerPopupContent.title}</PopupTitle> : null}
            <PopupContent className="top-banner-popup__content">
                {bannerPopupContent?.description ? (
                    <PopupText>
                        <SafeHtml html={bannerPopupContent.description} />
                    </PopupText>
                ) : null}
            </PopupContent>
            <PopupButtons isSimple>
                {linkUrl ? (
                    <TextLink
                        text={linkText}
                        href={linkUrl}
                        className="top-banner-popup__button"
                        isExternal
                        isBlock
                    />
                ) : null}
                <Button
                    onClick={handleClose}
                    isSecondary
                >
                    Fortsett å handle
                </Button>
            </PopupButtons>
        </>
    )
}

export default TopBannerPopupContent
